import { render, staticRenderFns } from "./EditDesignationComponent.vue?vue&type=template&id=5dcb3cbe&"
import script from "./EditDesignationComponent.vue?vue&type=script&lang=js&"
export * from "./EditDesignationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports